export const CreditPaymentFormMessages = {
    amountExceedsCreditRemaining:
        'Cannot enter more than the credit remaining.',
} as const;
